<template>
	<v-sheet color="transparent" class="pa-2">
		<h3 class="font-weight-light mb-5">
			Upcoming Appointments
		</h3>

		<div v-for="(day, str) in days" :key="str" class="mb-7">
			<h4 class="font-weight-light mb-5">
				{{ str }}
			</h4>
			<appointment-tile
				v-for="appointment in day"
				:key="appointment.id"
				:value="appointment.id"
				@click="focus = appointment.id"
			></appointment-tile>
		</div>
		<click-appointment
			:value="focus"
			@close="focus = null"
		></click-appointment>
		<p class="text-right" v-if="!error">
			<v-btn text @click="loadMore(true)">Load More Appointments</v-btn>
		</p>
	</v-sheet>
</template>
<style lang="less">
.tile {
	margin-right: 10px;
	display: inline-block;
}
</style>
<script>
import AppointmentTile from "@c/dashboard/AppointmentTile";
import ClickAppointment from "@c/dashboard/ClickAppointment";
export default {
	name: "CurrentAppointments",
	data: () => {
		return {
			focus: null,
			error: null,
		};
	},
	components: {
		AppointmentTile,
		ClickAppointment,
	},
	computed: {
		appointments() {
			return this.$store.getters["appointments/dashboard"](true);
		},
		projects() {
			return this.$store.state.projects.data;
		},
		haveProjects() {
			return Object.keys(this.projects).length > 0 ? true : false;
		},

		days() {
			const self = this;
			let days = {};
			self.appointments.reverse();
			self.appointments.forEach((a) => {
				let m = self.mwtimeutils.parseDateToMoment(a.start);
				let day = m.format("dddd, MMMM Do YYYY");
				if (!days[day]) {
					days[day] = [];
				}
				days[day].push(a);
			});
			for (var key in days) {
				days[key] = self.mwutils.sortByDate(days[key], "start");
				days[key] = days[key].reverse();
			}
			return days;
		},
	},
	watch: {
		haveProjects: {
			immediate: true,
			handler(v) {
				if (v) {
					this.loadMore(false);
				}
			},
		},
	},
	methods: {
		loadMore(last) {
			const self = this;
			if (last) {
				last = self.appointments[self.appointments.length - 1];
				last = last.start.toDate();
			}
			self.$store.dispatch("appointments/myNext10", last).then((fetch) => {
				if (fetch.done) {
					self.error = true;
				}
			});
		},
	},
};
</script>
